import { FILTER_CONTENT_TYPE, FILTER_VALUES } from '../../../../constants/FilterConstants';

export function createStaticDataFetcher(data) {
  const options = Array.isArray(data) ? data : [];
  return () => Promise.resolve({ data: options, isSuccess: true });
}

export function getProductTypeNamesFromCategories(categories) {
  const list = Array.isArray(categories) ? categories : [];
  const seenNames = new Set();
  const x3Name = (p) => (p?.x3_productname ?? p?.x3ProductName ?? p?.code ?? '').toString().trim();
  return list
    .filter((p) => p?.status !== 'Inactive')
    .filter((p) => {
      const name = x3Name(p).toUpperCase();
      if (!name || seenNames.has(name)) return false;
      seenNames.add(name);
      return true;
    })
    .map((p) => x3Name(p) || String(p.id))
    .sort();
}

export function buildFinalizedFilterOptions(productTypeNames) {
  return {
    [FILTER_VALUES.CREATED_BY]: [],
    [FILTER_VALUES.PRODUCT_TYPE]: productTypeNames?.length ? productTypeNames : ['—'],
    [FILTER_VALUES.START_DATE]: [],
    [FILTER_VALUES.END_DATE]: [],
  };
}

export function mapToMonthlyFilterOptions(items) {
  return (Array.isArray(items) ? items : []).map((item) =>
    item && typeof item === 'object' && 'id' in item && 'name' in item
      ? { ...item, value: item.value ?? item.id }
      : { id: item, name: item, text: item, value: item },
  );
}

export function buildMonthlyFinalizedFilterData(filterConfig, optionsMap, filterParams) {
  const selectedStartDate = filterParams?.[FILTER_VALUES.START_DATE] || '';
  const selectedEndDate = filterParams?.[FILTER_VALUES.END_DATE] || '';

  return (Array.isArray(filterConfig) ? filterConfig : []).map((item) => {
    if (item?.type === FILTER_CONTENT_TYPE.SELECT) {
      const options = mapToMonthlyFilterOptions(optionsMap?.[item.value] || []);
      return { ...item, api: createStaticDataFetcher(options), options: [] };
    }

    if (item?.type === FILTER_CONTENT_TYPE.DATE_PICKER) {
      if (item.value === FILTER_VALUES.START_DATE) {
        return { ...item, maxDate: selectedEndDate || undefined };
      }

      if (item.value === FILTER_VALUES.END_DATE) {
        return { ...item, minDate: selectedStartDate || undefined };
      }
    }

    return { ...item };
  });
}
